<template>
    <binary
        v-bind:operator="operatorText"
        v-bind:expression="expression"
        v-bind:path="path"
        v-bind:operator-is-text="true" />
</template>
<script>
    import binary from "./binary.vue";
    export default {
        components: { binary },
        props: {
            expression: { type: Object, required: true },
            path: {
                type: Array,
                required: false,
                default: function () {
                    return [];
                }
            }
        },
        computed: {
            operatorText() {
                if (!this.hasProperties) {
                    return "is before/after";
                }
                const strictCompareStr =
                    this.expression.PropertyDictionary.strictcompare === "true" ? "strictly" : " on or";
                const beforeAfter = this.expression.PropertyDictionary.beforeafter;

                return `is ${strictCompareStr} ${beforeAfter}`;
            },
            hasProperties() {
                return (
                    this.expression.PropertyDictionary.strictcompare && this.expression.PropertyDictionary.beforeafter
                );
            }
        }
    };
</script>
